import { CurrencyAmount } from "../../../utils/currency"

/** 
 * Interfaces for various line item unit price types
 * The unit price type of a line item dictates how the unit price should be displayed, calculated, and possibly changed.
 * */

export enum LineItemUnitPriceTypes {
    ChooseYourOwn = 'ChooseYourOwn',
    FixedPrice = 'FixedPrice'
}

/**
 * Properties common to all unit price types
 * defaultPrice: Starting Price of the line item.
 */
export interface LineItemUnitPriceConfiguration {
    defaultPrice: CurrencyAmount
}

/**
 * Properties for Choose Your Own Price: Where the user can select the amount of the line item.
 * componentName: Name for ID purposes.
 * maxAmount: Maximum input for price. Input will restrict input from exceeding the maximum.
 * minAmount: Minimum Valid input for price. If the input is less than the minimum amount, the component will report an invalid price.
 * (the input will directly restrict negative inputs.)
 * defaultPrice: Same as common property.
 */
export interface chooseYourOwnPriceConfiguration extends LineItemUnitPriceConfiguration {
    componentName: string,
    maxAmount: number,
    minAmount: number,
    defaultPrice: CurrencyAmount
}

export interface fixedPriceConfiguration extends LineItemUnitPriceConfiguration {
    componentName: string
    price: CurrencyAmount
}